export * from './generic-widget.component';
export * from './log-details-widget.component';
export * from './details';
